import { useQuery } from '@apollo/client';
import {USER} from "../userTypeDefs";

export const useQueryUser = (options?: any): any => (
  useQuery(USER, options)
);
